export default __webpack_public_path__ + "static/media/menu-1.2c6554a5.svg";